import { Box, Grid, Typography } from "@mui/material";

import colors from "../design/Colors";

export const TermsOfUse: React.FC = () => {
  const boxesList = [
    {
      text: "Realizamos los trámites y gestiones de acuerdo a lo establecido por la normativa vigente.",
      up: true,
    },
    {
      text: "Mantenemos a nuestros clientes permanentemente informados acerca del avance de sus trámites y les advertimos de cualquier circunstancia que los pudiera afectar.",
      up: true,
    },
    {
      text: "Preservamos la integridad, seguridad y confidencialidad de la documentación entregada por nuestros clientes.",
      up: true,
    },
    {
      text: "Atendemos a los clientes de lunes a viernes de 09.00 a 19.00 Horas, no obstante lo cual nos mantenemos disponibles a través del teléfono 098.000551.",
      up: true,
    },
    {
      text: "Mantenemos informados a nuestros clientes sobre novedades en materia de normativas aduaneras y de Comercio Exterior.",
      up: false,
    },
    {
      text: "No nos responsabilizamos por atrasos imputables a la DNA u otros organismos involucrados, así como tampoco por inconvenientes atribuibles a la documentación presentada por nuestros Clientes.",
      up: false,
    },
    {
      text: "Entregamos a nuestros Clientes las previsiones de costos que nos son solicitadas en un plazo no superior a 24 horas. Aseguramos que dichas previsiones no sufrirán modificaciones salvo por razones no imputables a MRM.",
      up: false,
    },
    {
      text: "Brindamos a todos nuestros Clientes que así lo requieran, asesoramiento integral en Comercio Internacional y normativas aduaneras.",
      up: false,
    },
  ];

  return (
    <Box
      sx={{
        width: "calc(100vw - 4rem)",
        height: { xs: "fit-content", lg: "45rem" },
        margin: "2rem auto 0 auto",
        padding: { sm: "2rem 4rem 2rem 4rem" },
        borderRadius: "14px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        sx={{
          color: "#1F6B45",
          maxWidth: "40rem",
          textAlign: "center",
          margin: { xs: "0 0 2rem 0", lg: "4rem" },
        }}
        fontSize={"1.7rem"}
        fontWeight={700}
        fontFamily={"Montserrat"}
      >
        Nuestras condiciones de servicios son las siguientes
      </Typography>

      <Grid container spacing={3}>
        {boxesList.map((item, index) => (
          <Grid
            key={index}
            sx={{
              display: "flex",
              alignItems: item.up ? "flex-end" : "flex-start",
              color: "white",
            }}
            item
            lg={3}
          >
            <Box
              sx={{
                backgroundColor: `${colors.deepGreen}`,
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
                padding: "1rem 1.5rem",
                borderRadius: "8px",
              }}
            >
              <Typography
                fontSize={"1rem"}
                fontWeight={500}
                fontFamily={"Montserrat"}
              >
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
